module.exports = __webpack_public_path__ + "media/images/premium/premium-plan-tx-0106a0255619dfcb5226a23a22571f71.svg";